import { render, staticRenderFns } from "./EncountersIndex.vue?vue&type=template&id=595e72da&"
import script from "./EncountersIndex.vue?vue&type=script&lang=js&"
export * from "./EncountersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports